import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { InstanceActions, InstanceDetailTabs } from "@/resources-def";
import { useTranslation } from "react-i18next";
import { useFormatter } from "@/hooks/useFormatter";

const RESOURCE = 'instances';

export const InstancePage = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const { formatDateTime } = useFormatter();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: RESOURCE, key: record.id, action: 'show' });
  };

  const columns = [
    { title: t("instances.fields.name"), dataIndex: "name" },
    { title: t("instances.fields.id"), dataIndex: "id", render: (text, record) => <a onClick={(e) => navigateToDetail(record, e) }>{text}</a> },
    { title: t("instances.fields.status"), dataIndex: "status", render:(value) => <InstanceStatus status={value} /> },
    { title: t("instances.fields.type"), dataIndex: "type" },
    { title: t("instances.fields.version"), dataIndex: "version" },
    { title: t("instances.fields.platform"), dataIndex: "platform" },
    { title: t("instances.fields.tenant"), dataIndex: "tenant" },
    { title: t("instances.fields.subdomain"), dataIndex: "subdomain", key: "subdomain" },
    { title: t("instances.fields.region"), dataIndex: "region", key: "region" },
    { title: t("instances.fields.zone"), dataIndex: "zone", key: "zone", render: (text, record) => record.zone.join(", ")},
    { title: t("instances.fields.nodegroup"), dataIndex: "nodegroup", key: "nodegroup" },
    { title: t("instances.fields.nodestatus"), dataIndex: "node_status", render:(value) => <InstanceStatus status={value} /> },
    { title: t("instances.fields.created_on"), dataIndex: "created_on", render: (value) => formatDateTime(value) },
    { title: t("instances.fields.created_by"), dataIndex: "created_by" }
  ];

  return (
    <ResourceListLayout
      resource={RESOURCE}
      actions={<InstanceActions />}
      columns={columns}
      details={InstanceDetailTabs()}
    >
    </ResourceListLayout>
  );
};